import React from 'react';
import { useTranslation } from 'react-i18next';
import { getSecretTypes } from '../utils/enums';

const SecretTypeSelect = ({ value, onChange }) => {
  const { t } = useTranslation();
  const secretTypes = getSecretTypes(t);

  return (
    <select
      value={value || ''}
      onChange={(e) => onChange(e.target.value)}
      className="input-field"
    >
      <option value="">{t('enums.secretTypes.All') || 'All Types'}</option>
      {secretTypes.map(type => (
        <option key={type.value} value={type.value}>
          {type.label}
        </option>
      ))}
    </select>
  );
};

export default SecretTypeSelect;